import Handlebars from "handlebars";

Handlebars.registerHelper("currentResourceType", function () {
  return window.RESOURCE.type;
});
